var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActor3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 106,
    viewBox: "0 0 105 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_702_182)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.33 105.94C81.2311 105.94 104.66 82.2245 104.66 52.97C104.66 23.7155 81.2311 0 52.33 0C23.4289 0 0 23.7155 0 52.97C0 82.2245 23.4289 105.94 52.33 105.94Z",
    fill: "#26ABDB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_702_182",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 106
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.33 105.94C81.2311 105.94 104.66 82.2245 104.66 52.97C104.66 23.7155 81.2311 0 52.33 0C23.4289 0 0 23.7155 0 52.97C0 82.2245 23.4289 105.94 52.33 105.94Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_702_182)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.33 50.0244C36.1 50.3484 35.56 77.881 40.65 83.4888L69.28 83.3066C69.28 83.3066 76.97 62.1206 71.57 49.8018L36.16 50.0244",
    fill: "#1D1D1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9468 67.2895L43.9072 67.417L43.992 81.0818L64.0317 80.9544L63.9468 67.2895Z",
    fill: "#F9C2A7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.83 77.2736C51.86 78.468 55.17 79.1765 58.43 79.1867C60.29 79.1867 62.19 78.9437 64.02 78.5996L63.95 67.293L43.91 67.4144L43.95 74.4798C45.36 75.7248 47.17 76.6156 48.83 77.2634V77.2736Z",
    fill: "#EDEDED"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.13 43.1312C76.16 48.8604 75.22 54.6504 72.59 59.6306C70.28 63.9831 66.81 67.4753 63.07 70.2691C60.04 72.5365 56.78 75.1784 52.93 74.8849C48.91 74.5812 45.75 71.1295 42.8 68.437C38.65 64.6613 35.36 59.9443 33.31 54.3973C32.05 50.976 31.46 47.1093 31.44 43.4146C31.33 24.9009 41.26 13.1894 53.61 13.1186C65.95 13.0376 76.03 24.6175 76.15 43.1312H76.13Z",
    fill: "#F9C2A7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.54 87.0115L62.74 80.5332L54.01 80.5838L45.28 80.6344L23.56 87.386C23.56 87.386 13.5 91.7892 12.47 105.535L54.17 105.272L95.87 105.009C94.66 91.273 84.55 87.0014 84.55 87.0014L84.54 87.0115Z",
    fill: "#F9C2A7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.54 87.0115L72.48 83.4282L54.14 102.215L35.51 83.6813L23.55 87.3962C23.55 87.3962 13.26 91.8702 12.46 105.545L73.43 105.161L96.28 105.019C94.16 90.777 84.54 87.0115 84.54 87.0115Z",
    fill: "#0D3953"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6801 32.4419C37.9601 37.6144 54.7701 36.3896 52.7101 36.2985L54.6901 25.8523L56.0001 36.4503C56.0001 36.4503 59.1601 37.6852 66.3201 36.4807L68.0401 29.2736L69.3101 35.924C69.3101 35.924 74.2101 34.5777 75.3201 32.1483C75.3201 32.1483 74.3501 13.8371 55.6101 12.0859C55.6101 12.0859 36.7801 12.4807 32.6801 32.4318V32.4419Z",
    fill: "#1D1D1B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2 18.2402C69.2 18.2402 77.48 71.5038 66.63 86.0293C66.63 86.0293 77.76 81.5451 79.14 72.435C79.14 72.435 87.92 33.4945 69.2 18.2504V18.2402Z",
    fill: "#1D1D1B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.57 18.0176C41.57 18.0176 32.68 71.7872 43.71 86.171C43.71 86.171 32.53 81.8286 31.03 72.7286C31.03 72.7286 23.04 33.5047 41.57 18.0176Z",
    fill: "#1D1D1B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.08 83.8227L54.32 103.652L75.02 84.1871L68.9 81.778L54.03 84.7944L42.03 80.6646L35.08 83.8227Z",
    fill: "#E9E9E9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.08 83.8226L44.36 79.6117L53.87 83.3165L63.34 79.4902L73.31 83.5796L59.3 92.6189L53.88 85.3409L48.14 92.6897L35.08 83.8226Z",
    fill: "#D6D6D6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_702_182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.67,
    height: 105.94,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActor3);
export default __webpack_public_path__ + "static/media/actor3.172c683772ad3a764672d9ee2f6448a9.svg";
export { ForwardRef as ReactComponent };